(function () {
  'use strict';

  const header   = document.getElementById('rp-header');
  if (!header) return;

  const burger      = header.querySelector('.rp-header__burger');
  const drawer      = document.getElementById('rp-drawer');
  const backdrop    = document.getElementById('rp-backdrop');
  const drawerClose = drawer?.querySelector('.rp-header__drawer-close');
  const drawerParents = drawer?.querySelectorAll('.rp-header__drawer-parent');

  // ── CSS variable : hauteur réelle du header (annonce incluse) ──────────────
  function syncHeight() {
    document.documentElement.style.setProperty(
      '--rp-header-height',
      header.offsetHeight + 'px'
    );
  }
  syncHeight();
  window.addEventListener('resize', syncHeight, { passive: true });

  // ── Transparent → blanc au scroll ─────────────────────────────────────────
  if (header.dataset.transparent === 'true') {
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Drawer helpers ─────────────────────────────────────────────────────────
  function openDrawer() {
    drawer?.setAttribute('aria-hidden', 'false');
    backdrop?.setAttribute('aria-hidden', 'false');
    burger?.setAttribute('aria-expanded', 'true');
    burger?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer?.setAttribute('aria-hidden', 'true');
    backdrop?.setAttribute('aria-hidden', 'true');
    burger?.setAttribute('aria-expanded', 'false');
    burger?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  burger?.addEventListener('click', () => {
    burger.getAttribute('aria-expanded') === 'true' ? closeDrawer() : openDrawer();
  });

  drawerClose?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // ── Accordéon sous-menus (drawer) ─────────────────────────────────────────
  drawerParents?.forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      const sub    = btn.nextElementSibling;

      // Ferme tout
      drawerParents.forEach(other => {
        other.setAttribute('aria-expanded', 'false');
        const s = other.nextElementSibling;
        if (s) s.setAttribute('aria-hidden', 'true');
      });

      // Ouvre si c'était fermé
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        sub?.setAttribute('aria-hidden', 'false');
      }
    });
  });
})();